module.exports = __webpack_public_path__ + "media/images/schoology_logo_square_36-4c05ea169fe5eb98f4aebea2829443ba.png";